import { routes } from '@/lego/routes.js';

export function getSeoFromRouteName(name) {
  const seoInfo = routes.find(route => route.name === name).meta.seo;
  const openGraph = seoInfo?.openGraph ?? [];

  Object.keys(openGraph.properties)
    .filter(key => !openGraph.properties[key])
    .forEach(key => delete openGraph.properties[key]);

  openGraph.properties.image = process.env.MIX_APP_URL + openGraph.properties.image;

  return {
    meta: seoInfo ?? [],
    openGraph: openGraph,
  };
}
